// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__wlCGh","headingIcon":"Dashboard_headingIcon__o2ooj"};